const moment = require('moment');
const State = require('../helpers.js').State;

module.exports = State({
    vin: '',
    inProgress: false,
    classes: [],
    brands: [],
    models: [],
    class: '',
    brand: '',
    model: '',
    maxWeight: '',
    year: '',
    seatNo: '',
    enginePower: '',
    engineDisplacement: '',
    energySource: '',
    plateNo: '',
    isTaxi: false,
    isFirstVinEmptyResponse: true,
    showPromoCar: (moment().diff(moment("02.12.2024", 'DD.MM.YYYY')) > 0 && moment().diff(moment("01.02.2025", 'DD.MM.YYYY')) < 0), // [~] the 'after' date written here is the first day the banner is not shown anymore. in genere +1 fata de ce ne da roxana'n task...

});